import script from "./AddQuestionView.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddQuestionView.vue?vue&type=script&lang=ts&setup=true"

import "./AddQuestionView.vue?vue&type=style&index=0&id=123733fc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.5.5__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-123733fc"]])

export default __exports__